import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ErrorHandlerService } from '../error-handler.service';
import { AnimationsService } from '../animations.service';
import { environment } from '../../../environments/environment';
import { API } from '../api';
import { AuthService } from 'src/app/security/auth.service';

@Injectable({
  providedIn: 'root'
})
export class MatriculaAlunoService {

  constructor(
    private http: HttpClient,
    private animationsService: AnimationsService,
    private errorHandlerService: ErrorHandlerService,
    private authService: AuthService,
  ) { }

  cadastrar(data): Observable<any> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.post(`${environment.baseUrl}${API.matriculaAluno.cadastrar}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao enviar os dados', []))
      );
  }

  buscarPorId(id): Observable<any> {
    
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('matriculaId', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.matriculaAluno.buscarPorId}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter matrícula', []))
      );
  }

  buscarMinhasMatriculas(id, usuarioLogadoId): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('alunoId', id).set('usuarioLogadoId', usuarioLogadoId);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.matriculaAluno.buscarMinhasMatriculas}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter matrícula', []))
      );
  }

  consultarMeusProfessores(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('matriculaId', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.matriculaAluno.consultarMeusProfessores}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter professores', []))
      );
  }

  jaExistenteMatricula(alunoId, usuarioLogadoId): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('alunoId', alunoId).set('usuarioLogadoId', usuarioLogadoId);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.matriculaAluno.jaExistenteMatricula}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao consultar matriculas', []))
      );
  }

  consultarDocumentosPendentes(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('matriculaId', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.matriculaAluno.consultarDocumentosPendentes}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter documentos', []))
      );
  }

  consultaAluno(matriculaId, usuarioLogadoId): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('matriculaId', matriculaId).set('usuarioLogadoId', usuarioLogadoId);
    const usuario = this.authService.getToken();
    
    return this.http.get(`${environment.baseUrl}${API.matriculaAluno.consultaAluno}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter documentos', []))
      );
  }

  gerarPendenciaDocumental(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('matriculaId', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.matriculaAluno.gerarPendenciaDocumental}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter documentos', []))
      );
  }

  deletar(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('matriculaId', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.matriculaAluno.deletar}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao excluir matrícula', []))
      );
  }

  AtualizarMaterialLiberado(data): Observable<any> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.post(`${environment.baseUrl}${API.matriculaAluno.atualizarMaterialLiberado}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao enviar os dados', []))
      );
  }
}
